var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 793,
    viewBox: "0 0 552 793",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_11378_19278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.269 283.829C506.877 265.112 511.308 244.724 511.251 224.097V151.587C511.302 131.488 507.134 111.605 499.02 93.2422C490.645 74.4764 478.557 57.6274 463.496 43.725C448.158 29.314 430.199 18.0237 410.606 10.4752C390.728 2.80641 369.61 -1.08459 348.323 -1.00037H185.521V340.198L306.579 211.865H427.304L185.604 492.996V633.561L306.663 505.27H427.304L286.458 669.206H348.365C369.646 669.244 390.749 665.31 410.606 657.605C430.192 650.069 448.14 638.777 463.454 624.355C478.515 610.453 490.603 593.604 498.978 574.838C507.096 556.476 511.264 536.592 511.21 516.493V444.067C511.249 423.456 506.818 403.085 498.227 384.377C489.489 365.267 476.926 348.18 461.325 334.187C476.953 320.143 489.531 302.999 498.269 283.829Z",
    fill: "#EAF1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.138 59.0671H306.121V211.907H427.138V59.0671Z",
    fill: "#FF9B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.479 340.198L306.537 211.865V59.0671L185.479 187.358C185.479 187.358 39.9164 337.886 27.1427 366.175C-3.41413 433.725 -4.29077 473.827 9.31786 527.842C20.4636 572.147 74.5224 666.095 168.322 640.706C174.581 639.477 180.462 636.768 185.479 632.804V633.56L189.653 629.357C192.479 626.721 195.141 623.913 197.626 620.95L306.704 505.353V352.43L185.646 480.721C185.646 480.721 156.425 497.535 130.168 448.354C108.335 407.874 157.009 370.379 185.479 340.198Z",
    fill: "#FF8816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.138 352.43H306.121V505.27H427.138V352.43Z",
    fill: "#FF9B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.709 550.374L260.995 553.443V400.645L264.251 397.03L263.709 550.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.709 257.011L260.995 260.08V107.282L264.251 103.667L263.709 257.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.016 186.728C339.934 186.728 410.482 127.879 410.482 127.879L377.087 121.111L404.93 73.6533L333.464 132.502L366.86 139.354L339.016 186.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.588 485.345C334.507 485.345 405.096 426.496 405.096 426.496L371.701 419.77L399.544 372.271L328.203 431.456L361.599 438.265L333.588 485.345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11378_19278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 550.228,
    height: 794,
    fill: "white",
    transform: "translate(0.885742 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg1);
export default __webpack_public_path__ + "static/media/login_bg1.b1a72f548f238926e1c9e663e18c953f.svg";
export { ForwardRef as ReactComponent };